import { useTranslation } from 'react-i18next';
import { Linkedin, Facebook, Instagram } from 'lucide-react';
import aeLogo from '@/assets/AE_Logo_White.webp';
import laContessinaLogo from '@/assets/LA_CONTESSINA-white.webp';
import bbLogo from '@/assets/BB_white.webp';
import pataviumartLogo from '@/assets/Pataviumart.White.webp';
import italianStoneLogo from '@/assets/Italian_Stone_White.webp';

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-16 px-6 border-t border-border">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
          <img src={aeLogo} alt="Atelier Elements" className="h-8 mx-auto" />
          <p className="text-sm text-muted-foreground font-light mt-3 italic">
            {t('footer.tagline')}
          </p>
          <div className="flex items-center justify-center gap-12 mt-8 opacity-60">
            <button onClick={() => scrollTo('la-contessina')} className="hover:opacity-80 transition-opacity">
              <img src={laContessinaLogo} alt="La Contessina" className="h-10 w-auto object-contain" />
            </button>
            <button onClick={() => scrollTo('barj-buzzoni')} className="hover:opacity-80 transition-opacity">
              <img src={bbLogo} alt="Barj Buzzoni" className="h-5 w-auto object-contain" />
            </button>
            <button onClick={() => scrollTo('pataviumart')} className="hover:opacity-80 transition-opacity">
              <img src={pataviumartLogo} alt="Pataviumart" className="h-6 w-auto object-contain" />
            </button>
            <button onClick={() => scrollTo('italian-stone-source')} className="hover:opacity-80 transition-opacity">
              <img src={italianStoneLogo} alt="Italian Stone Source" className="h-5 w-auto object-contain" />
            </button>
          </div>

          {/* Social links */}
          <div className="flex items-center justify-center gap-5 mt-8">
            <a href="https://linkedin.com/company/atelier-elements" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61572116038682" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a href="https://www.instagram.com/atelierelements_/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
          </div>

          <div className="w-12 h-px bg-primary/30 mx-auto my-8" />
          <p className="text-xs text-muted-foreground/50">
            {t('footer.rights', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
